import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, User, Menu, X, ChevronDown } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useAuth } from '../context/AuthContext';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const { cartItems, toggleCart } = useCart();
  const { user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  const navItems = [
    { path: '/', label: 'Inicio' },
    { path: '/productos', label: 'Productos' },
    { path: '/presentacion', label: 'Nuestras Picadas' },
    { path: '/contacto', label: 'Contacto' },
  ];

  const cartItemCount = (cartItems || []).reduce((total, item) => total + item.quantity, 0);

  return (
    <>
      <div className="bg-[#2C1810] text-[#EFE1C4] text-center py-2 text-sm">
        Armá tu picada a medida  Productos frescos artesanales
      </div>
      <header className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-[#1a0f0a]/95 backdrop-blur-md shadow-lg' : 'bg-[#1a0f0a]'}`}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            <Link to="/" className="flex items-center space-x-2">
              <span className="text-2xl md:text-3xl font-bold text-[#EFE1C4] tracking-wider">PICADAS DEL CAMPO</span>
            </Link>
            <nav className="hidden md:flex items-center space-x-8">
              {navItems.map((item) => (
                <Link key={item.path} to={item.path} className={`text-sm font-medium transition-colors hover:text-[#D4A574] ${location.pathname === item.path ? 'text-[#D4A574]' : 'text-[#EFE1C4]'}`}>
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="flex items-center space-x-4">
              <button onClick={toggleCart} className="relative text-[#EFE1C4] hover:text-[#D4A574] transition-colors">
                <ShoppingCart className="w-6 h-6" />
                {cartItemCount > 0 && (
                  <span className="absolute -top-2 -right-2 bg-[#D4A574] text-[#1a0f0a] text-xs font-bold rounded-full w-5 h-5 flex items-center justify-center">{cartItemCount}</span>
                )}
              </button>
              <Link to={user ? '/perfil' : '/login'} className="text-[#EFE1C4] hover:text-[#D4A574] transition-colors">
                <User className="w-6 h-6" />
              </Link>
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="md:hidden text-[#EFE1C4]">
                {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
              </button>
            </div>
          </div>
        </div>
        {isMenuOpen && (
          <div className="md:hidden bg-[#1a0f0a] border-t border-[#3a2a1a]">
            <div className="px-4 py-3 space-y-2">
              {navItems.map((item) => (
                <Link key={item.path} to={item.path} className={`block py-2 text-sm font-medium ${location.pathname === item.path ? 'text-[#D4A574]' : 'text-[#EFE1C4]'}`}>
                  {item.label}
                </Link>
              ))}
            </div>
          </div>
        )}
      </header>
    </>
  );
};

export default Header;
